import { getData, postData } from 'src/api/http.service';
import { handleApiError, handleApiSuccess } from 'src/utils/general.utils';
import { getAPIEndpoints } from 'src/utils';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';

const StudentmanagementActions = {
  STUDENT_DETAILS_LIST_SUCCESS: '[API] : Get students details action.',
  STUDENT_SUBSCRIPTIONS_SUCCESS: '[API] : Get students subscription details action.',
  STUDENT_INVOICES_SUCCESS: '[API] : Get students invoiceslist action.',
  STUDENT_EMAIL_VERIFY_SUCCESS: '[API] : Verify student email action.',
};

/*
    Plain Actions
*/

function StudentDetailsSuccessAction(payload) {
  return {
    type: StudentmanagementActions.STUDENT_DETAILS_LIST_SUCCESS,
    payload,
  };
}

function StudentSubscriptionsSuccessAction(payload) {
  return {
    type: StudentmanagementActions.STUDENT_SUBSCRIPTIONS_SUCCESS,
    payload,
  };
}

function StudentInvoicesSuccessAction(payload) {
  return {
    type: StudentmanagementActions.STUDENT_INVOICES_SUCCESS,
    payload,
  };
}

function StudentEmailVerifySuccessAction(payload) {
  return {
    type: StudentmanagementActions.STUDENT_SUBSCRIPTIONS_SUCCESS,
    payload,
  };
}
/*
    Async Actions
*/

function GetStudentDetailsAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(StudentDetailsSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      dispatch(StudentDetailsSuccessAction([]));
      return false;
    }
  };
}

function GetStudentSubscriptionsListAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(StudentSubscriptionsSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(StudentSubscriptionsSuccessAction([]));
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}
function GetStudentInvoicesListAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(StudentInvoicesSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(StudentInvoicesSuccessAction([]));
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function VerifyStudentEmailAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(url, body, headers);
      dispatch(StudentEmailVerifySuccessAction(response));
      setTimeout(() => {
        dispatch(
          GetStudentDetailsAction(
            `${getAPIEndpoints().getStudentInfo}?mobileNumber=${body.mobile}`,
            headers
          )
        );
      }, 2000);
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}
function GetInvoiceAction(url, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await getData(url);
      let formattedResponse = handleApiSuccess(response, metaData);
      dispatch(ApiCallSuccessAction(formattedResponse));
      //dispatch(GetInvoiceSuccessAction(response.data));
      return response.data;
    } catch (err) {
      let formattedError = handleApiError(err);
      dispatch(ApiCallFailedAction(formattedError));
      return false;
    }
  };
}
export {
  StudentmanagementActions,
  GetStudentDetailsAction,
  GetStudentSubscriptionsListAction,
  GetStudentInvoicesListAction,
  VerifyStudentEmailAction,
  GetInvoiceAction,
};
